import { render } from "./Mailings.vue?vue&type=template&id=5649723e"
import script from "./Mailings.vue?vue&type=script&lang=js"
export * from "./Mailings.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaspur/Code/online-alv/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__